import {workingSet} from './mergeContext';
import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from '../find';
import Resource from '../../entities/resource';
export function deleteResource(resource: Resource, mergeId?: string) {
let targetImportSource = 'merge';
if (!mergeId) {targetImportSource = 'delete';mergeId = resource.id;}
const _work = workingSet();




resource.status = 'D';
resource.addedOn = newHRTimestamp();
resource.addedBy = getCurrentUserId();
resource.importSource = targetImportSource;
resource.importId = mergeId;
store.dispatch(Actions.ResourceActions.removeResourceQueue(resource));
}


